import {AppBar, Tabs, Tab} from '@material-ui/core'
import {ChangeEvent, useEffect, useState} from 'react'
import {History} from 'history'
import {withStyles} from '@material-ui/core/styles'

type Props = {
  history: History
  loggedIn: boolean
}
const StyledTabs = withStyles({
  indicator: {
    backgroundColor: 'white',
  },
})(Tabs)

const NavBar: React.FC<Props> = ({history, loggedIn}: Props) => {
  const [location, setLocation] = useState(history.location)
  const createListener = () => {
    history.listen((newLocation) => setLocation(newLocation))
  }
  const onChange = (_event: ChangeEvent<{}>, newValue: string) => {
    history.push(newValue)
  }
  useEffect(createListener, [history])
  if (!loggedIn) {
    return null
  }
  return (
    <AppBar position="static">
      <StyledTabs value={location.pathname} onChange={onChange}>
        <Tab label="Logout" value="/logout" />
        <Tab label="Routines" value="/routines" />
        <Tab label="Actions" value="/actions" />
        <Tab label="Users" value="/users" />
      </StyledTabs>
    </AppBar>
  )
}
export default NavBar
